"use strict";
(self.webpackChunkdemel_shopify_template = self.webpackChunkdemel_shopify_template || []).push([
  [226], {
    1214: (t, e, i) => {
      i.r(e);
      var s = ['a[href]:not([tabindex^="-"])', 'area[href]:not([tabindex^="-"])', 'input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"])', 'input[type="radio"]:not([disabled]):not([tabindex^="-"])', 'select:not([disabled]):not([tabindex^="-"])', 'textarea:not([disabled]):not([tabindex^="-"])', 'button:not([disabled]):not([tabindex^="-"])', 'iframe:not([tabindex^="-"])', 'audio[controls]:not([tabindex^="-"])', 'video[controls]:not([tabindex^="-"])', '[contenteditable]:not([tabindex^="-"])', '[tabindex]:not([tabindex^="-"])'];

      function n(t) {
        this._show = this.show.bind(this), this._hide = this.hide.bind(this), this._maintainFocus = this._maintainFocus.bind(this), this._bindKeypress = this._bindKeypress.bind(this), this.$el = t, this.shown = !1, this._id = this.$el.getAttribute("data-a11y-dialog") || this.$el.id, this._previouslyFocused = null, this._listeners = {}, this.create()
      }

      function o(t, e) {
        return function (t) {
          return Array.prototype.slice.call(t)
        }((e || document).querySelectorAll(t))
      }

      function d(t) {
        (t.querySelector("[autofocus]") || t).focus()
      }

      function r() {
        o("[data-a11y-dialog]").forEach((function (t) {
          new n(t)
        }))
      }
      n.prototype.create = function () {
        return this.$el.setAttribute("aria-hidden", !0), this.$el.setAttribute("aria-modal", !0), this.$el.setAttribute("tabindex", -1), this.$el.hasAttribute("role") || this.$el.setAttribute("role", "dialog"), this._openers = o('[data-a11y-dialog-show="' + this._id + '"]'), this._openers.forEach(function (t) {
          t.addEventListener("click", this._show)
        }.bind(this)), this._closers = o("[data-a11y-dialog-hide]", this.$el).concat(o('[data-a11y-dialog-hide="' + this._id + '"]')), this._closers.forEach(function (t) {
          t.addEventListener("click", this._hide)
        }.bind(this)), this._fire("create"), this
      }, n.prototype.show = function (t) {
        return this.shown || (this._previouslyFocused = document.activeElement, this.$el.removeAttribute("aria-hidden"), this.shown = !0, d(this.$el), document.body.addEventListener("focus", this._maintainFocus, !0), document.addEventListener("keydown", this._bindKeypress), this._fire("show", t)), this
      }, n.prototype.hide = function (t) {
        return this.shown ? (this.shown = !1, this.$el.setAttribute("aria-hidden", "true"), this._previouslyFocused && this._previouslyFocused.focus && this._previouslyFocused.focus(), document.body.removeEventListener("focus", this._maintainFocus, !0), document.removeEventListener("keydown", this._bindKeypress), this._fire("hide", t), this) : this
      }, n.prototype.destroy = function () {
        return this.hide(), this._openers.forEach(function (t) {
          t.removeEventListener("click", this._show)
        }.bind(this)), this._closers.forEach(function (t) {
          t.removeEventListener("click", this._hide)
        }.bind(this)), this._fire("destroy"), this._listeners = {}, this
      }, n.prototype.on = function (t, e) {
        return void 0 === this._listeners[t] && (this._listeners[t] = []), this._listeners[t].push(e), this
      }, n.prototype.off = function (t, e) {
        var i = (this._listeners[t] || []).indexOf(e);
        return i > -1 && this._listeners[t].splice(i, 1), this
      }, n.prototype._fire = function (t, e) {
        var i = this._listeners[t] || [],
          s = new CustomEvent(t, {
            detail: e
          });
        this.$el.dispatchEvent(s), i.forEach(function (t) {
          t(this.$el, e)
        }.bind(this))
      }, n.prototype._bindKeypress = function (t) {
        this.$el.contains(document.activeElement) && (this.shown && "Escape" === t.key && "alertdialog" !== this.$el.getAttribute("role") && (t.preventDefault(), this.hide(t)), this.shown && "Tab" === t.key && function (t, e) {
          var i = function (t) {
            return o(s.join(","), t).filter((function (t) {
              return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
            }))
          }(t),
            n = i.indexOf(document.activeElement);
          e.shiftKey && 0 === n ? (i[i.length - 1].focus(), e.preventDefault()) : e.shiftKey || n !== i.length - 1 || (i[0].focus(), e.preventDefault())
        }(this.$el, t))
      }, n.prototype._maintainFocus = function (t) {
        !this.shown || t.target.closest('[aria-modal="true"]') || t.target.closest("[data-a11y-dialog-ignore-focus-trap]") || d(this.$el)
      }, "undefined" != typeof document && ("loading" === document.readyState ? document.addEventListener("DOMContentLoaded", r) : window.requestAnimationFrame ? window.requestAnimationFrame(r) : window.setTimeout(r, 16));
      var a = i(2908),
        h = i(4412),
        l = i(9535);
      class c extends HTMLElement {
        get role() {
          return this.getAttribute("role")
        }
        get modalMode() {
          return this.getAttribute("modal-mode")
        }
        getTemplate() {
          const t = document.createElement("template");
          return t.innerHTML = `\n    <div ${"alertdialog" === this.role ? "" : "data-a11y-dialog-hide"}></div>\n    <div role="document">\n    ${"alertdialog" === this.role ? "" : '<button type="button" data-a11y-dialog-hide aria-label="Close dialog">\n          <span class="text-centi font-tertiary tracking-4">CLOSE</span>\n          <svg class="c-ico"><use xlink:href="#icon-close" /></svg>\n      </button>'}\n    </div>\n    `, t.content.cloneNode(!0)
        }
        constructor() {
          super(), this.dialog = void 0, this.setupListeners()
        }
        connectedCallback() {
          const t = this.getTemplate();
          t.querySelector("[role=document]")?.append(...this.children), this.append(t);
          const e = n.prototype.hide;
          n.prototype.hide = function (t) {
            if ("side" === this.$el.getAttribute("modal-mode")) {
              let t;
              const i = (0, a.p)("animationend", this.$el, (() => {
                e.call(this), this.$el.classList.remove("hide"), clearTimeout(t)
              }), {
                once: !0
              });
              return t = setTimeout((() => {
                i(), e.call(this), this.$el.classList.remove("hide")
              }), 500), this.$el.classList.add("hide"), this
            }
            return e.call(this)
          }, this.dialog = new n(this), this.dialog.on("show", (() => {
            const t = (0, h.U2)(".js-header-burger");
            t?.classList.contains("is-mobile-nav-open") && t.click(), "MiniBasket" == this.id && (0, l.d)(this.querySelector("[role=document]"))
          })).on("hide", (() => {
            "side" === this.modalMode && this.dialog.$el.classList.remove("hide"), "MiniBasket" == this.id && (0, l.A)(this.querySelector("[role=document]"))
          })), this.setAttribute("aria-hidden", "true"), this.removeAttribute("hidden"), this.dispatchEvent(new CustomEvent("propify:defined"))
        }
        show() {
          return this.dialog?.show(), ((0, h.U2)("[autofocus], button, input", this) ?? (0, h.U2)("button", this))?.focus(), !1
        }
        hide() {
          this.dialog?.hide()
        }
        toggle() {
          return this.dialog?.shown ? this.hide() : this.show(), !1
        }
        setupListeners() {
          const t = (0, h.go)(`[data-propify-dialog-show="${this.id}"`);
          for (const e of t) (0, a.p)("click", e, (() => {
            this.show()
          }))
        }
      }
      customElements.define("propify-dialog", c)
    },
    2908: (t, e, i) => {
      function s(t, e, i, s) {
        return e || (e = document), e.addEventListener(t, i, s), () => e.removeEventListener(t, i, s)
      }
      i.d(e, {
        p: () => s
      })
    },
    9535: (t, e, i) => {
      let s;
      i.d(e, {
        A: () => d,
        d: () => o
      });
      const n = async () => {
        s = await i.e(436).then(i.bind(i, 5239))
      };
      async function o(t, e = {}) {
        s || await n(), s.clearAllBodyScrollLocks(), s.disableBodyScroll(t, e)
      }
      async function d(t) {
        s || await n(), s.enableBodyScroll(t)
      }
    }
  }
]);